var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    width: 60,
    height: 60,
    style: {},
    filter: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.032 0c-8.768-0.064-16 7.136-16.032 16-0.032 8.8 7.104 15.936 15.936 16 8.864 0.032 16-7.040 16.064-15.936 0.064-8.8-7.072-15.968-15.968-16.064zM16 30.080c-7.776 0-14.016-6.24-14.080-14.016-0.032-7.808 6.272-14.112 14.080-14.112s14.048 6.208 14.080 14.016c0.032 7.808-6.272 14.112-14.080 14.112zM12.096 13.536c2.368 0 4.352-1.984 4.384-4.32 0-2.368-1.984-4.352-4.352-4.352-2.368-0.032-4.352 1.952-4.384 4.32 0 2.336 2.016 4.352 4.352 4.352zM21.664 14.688c2.336 0.032 4.352-1.984 4.384-4.352 0.032-2.304-1.984-4.352-4.32-4.384-2.336 0-4.384 1.984-4.384 4.352-0.032 2.336 1.952 4.352 4.32 4.384zM22.816 15.552c-2.368 0-4.352 1.984-4.352 4.352s1.984 4.352 4.352 4.32c2.368 0 4.384-1.984 4.352-4.32 0-2.368-1.984-4.352-4.352-4.352zM14.464 19.904c-2.4 0-4.32 1.952-4.288 4.32 0 2.4 1.952 4.32 4.352 4.32 2.393-0.032 4.32-1.979 4.32-4.377 0-0.003 0-0.005 0-0.008v0c-0.032-2.4-1.952-4.288-4.384-4.256zM12.128 17.472c0-2.368-1.984-4.32-4.352-4.32-2.368 0.032-4.288 1.984-4.288 4.384 0 2.368 1.984 4.352 4.352 4.32 2.368 0 4.288-1.984 4.288-4.384zM14.88 16.032c0 0.608 0.512 1.12 1.152 1.12 0.608-0.032 1.12-0.544 1.12-1.152-0.023-0.62-0.529-1.115-1.152-1.12h-0c-0.64 0-1.12 0.512-1.12 1.152z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilm);
export default __webpack_public_path__ + "static/media/film.11fb8a80bce4239544086df6a905a916.svg";
export { ForwardRef as ReactComponent };